export function getStoreName(): string {
  return 'EnrichlyRemembersStore';
}
